const tint = (id) => (id % 4) + 1

// A single book standing on the shelf. Clicking opens the modal (React state).
const BookCard = ({ book, onOpen }) => {
  const open = (event) => {
    event.preventDefault()
    onOpen()
  }

  return (
    <article className="book">
      <div className="book__stage">
        <a className="book__cover-link" href={`/books/${book.id}`} onClick={open}>
          {book.cover_url ? (
            <img className="book__cover" src={book.cover_url} alt={book.title} />
          ) : (
            <span className={`book__cover book__cover--blank tint-${tint(book.id)}`}>
              <span className="blank-title">{book.title}</span>
              <span className="blank-author">{book.author}</span>
            </span>
          )}
        </a>
      </div>

      <div className="book__shelf" />

      <div className="book__caption">
        <a className="book__title" href={`/books/${book.id}`} onClick={open}>
          {book.title}
        </a>
        <span className="book__author">{book.author}</span>
        {book.genre && <span className="book__genre">{book.genre}</span>}
      </div>
    </article>
  )
}

export default BookCard
